import type { ExtractUnionFromArray } from 'utils/typeUtils';

import { CustomEntity } from 'enums/extendedEntityType';

import { EntityType, LeadActivityType } from 'store/client/graphql';

export enum NestedViewConfigType {
  DetailsView = 'DetailsView',
  ListView = 'ListView',
  SecondaryView = 'SecondaryView',
}

/**
 * A list of entity types with detail views that will always render as nested.
 */
export const DetailsViewExceptions = [
  EntityType.LEAD_ACTIVITY,
  LeadActivityType.FORM,
  LeadActivityType.INQUIRY,
  LeadActivityType.PHONE_CALL,
  LeadActivityType.WALK_IN,
  LeadActivityType.TEST_DRIVE,
  CustomEntity.RETAIL_BULK_ADJUSTMENT,
  CustomEntity.ROOFTOP_INTEGRATIONS,
];

export enum SecondaryViewType {
  DETAILS = 'DETAILS',
  LIST = 'LISTS',
}

export enum SecondaryViewWidth {
  DEFAULT = '315px',
  EXPANDED = '630px',
}

export type DetailsViewExceptionsEntityType = ExtractUnionFromArray<typeof DetailsViewExceptions>;
